var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVortexWater01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 438 416",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#09B2C9;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M212.85,318.21a80.15,80.15,0,0,1-71.77-115.77c.06-.13.12-.26.19-.38,1.07-2.13,2.25-4.22,3.5-6.24l0,0c1.16-1.85,2.35-3.77,3.45-5.66l60.28-103.2a5,5,0,0,1,8.65,0l60.27,103.2c1.11,1.89,2.3,3.81,3.46,5.66l0,0c1.25,2,2.42,4.11,3.5,6.24.07.12.13.25.19.38a80.14,80.14,0,0,1-71,115.77ZM150.16,206.68l0,0a70.11,70.11,0,1,0,125.44,0l0,0h0c-.95-1.9-2-3.77-3.12-5.57l0-.05c-1.19-1.92-2.42-3.89-3.59-5.9l-56-95.79L156.9,195.16c-1.17,2-2.4,4-3.59,5.9l0,.05c-1.12,1.8-2.17,3.67-3.12,5.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M236.14,292.88a5,5,0,0,1-1.21-9.87c11.49-2.87,19.64-9.67,24.22-20.19a43.18,43.18,0,0,0,3.53-15.14,5,5,0,1,1,10,0,52.64,52.64,0,0,1-4.36,19.13c-4,9.3-12.71,21.35-31,25.92A5.15,5.15,0,0,1,236.14,292.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVortexWater01);
export default __webpack_public_path__ + "static/media/Vortex_Water-01.2f698211d305504234eca002d89ec969.svg";
export { ForwardRef as ReactComponent };